import { FC } from 'react';
import { useLoggedinUser } from '@hooks';
import { WizardResultForInfraSeller, WizardResultForVehicleSeller } from '@components/portal/wizard';
import { Navigate } from 'react-router-dom';
import { LoadingLayout } from '@components/common';

export const WizardResult: FC = () => {
	const user = useLoggedinUser();
	const userSellVehicles = user?.isDealer(user?.role);
	const userSellInfra = user?.isChargingPartner(user?.role);

	if (!user) {
		return <LoadingLayout />;
	}

	if (userSellVehicles) {
		return <WizardResultForVehicleSeller />;
	} else if (userSellInfra) {
		return <WizardResultForInfraSeller />;
	} else if (user?.isHybridSeller()) {
		return <WizardResultForVehicleSeller />;
	} else {
		return <Navigate to="../" />;
	}
};
